<template>
  <div>
    <header :class="{ light: activeNav == 4 }">
      <a @click="toSubNav(0, 0)" class="logo">
        <img src="../assets/logo.png" class="logoDark">
        <img src="../assets/logoHeader.png" class="logoLight">
      </a>

      <ul class="nav">
        <li :class="{ active: activeNav == 0 }">
          <a @click="toSubNav(0, 0)">首页</a>
        </li>
        <li :class="{ active: activeNav == 1 }">
          <a @click="toSubNav(1, 0)">产品中心</a>
          <div class="subnav_prod">
            <div class="wrap">
              <div class="menu_box">
                <div class="item">
                  <h4>工业质检行业专机</h4>
                  <div class="bottom">
                    <a @click="toSubNav(1, 1)">2D-AOI PCBA检测设备</a>
                    <a @click="toSubNav(1, 2)">3D-AOI PCBA检测设备</a>
                    <a @click="toSubNav(1, 3)">3D-SPI锡膏检测设备</a>
                    <a @click="toSubNav(1, 4)">DIP-AOI插件检测设备</a>
                  </div>
                </div>
                <div class="item">
                  <h4>智能模组产品</h4>
                  <div class="bottom">
                    <a @click="toSubNav(1, 5)">AI智能相机</a>
                    <a @click="toSubNav(1, 6)">智能光源系统</a>
                    <a @click="toSubNav(1, 7)">AI智能盒子</a>
                    <a @click="toSubNav(1, 8)">双目结构光3D相机</a>
                  </div>
                </div>
                <div class="item">
                  <h4>AI智能平台</h4>
                  <div class="bottom">
                    <a @click="toSubNav(1, 9)">视觉应用平台</a>
                    <a @click="toSubNav(1, 10)">算法生成平台</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li :class="{ active: activeNav == 2 }" style="position: relative;">
          <a @click="toSubNav(2, 0)">核心技术</a>
          <div class="subnav">
            <div class="wrap">
              <div class="menu_box">
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(2, 1)">AutoML</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(2, 2)">可信赖AI</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(2, 3)">主动学习</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(2, 4)">小样本学习</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(2, 5)">联邦学习</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li :class="{ active: activeNav == 3 }" style="position: relative;">
          <a @click="toSubNav(3, 0)">行业应用</a>
          <div class="subnav">
            <div class="wrap">
              <div class="menu_box">
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 1)">半导体晶圆</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 2)">电子元器件</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 3)">新能源电池</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 4)">太阳能光伏</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 5)">3C电子</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 6)">汽车制造</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 7)">纺织工业</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(3, 8)">细菌检测</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li :class="{ active: activeNav == 4 }" style="position: relative;">
          <a @click="toSubNav(4, 0)">关于识渊</a>
          <div class="subnav">
            <div class="wrap">
              <div class="menu_box">
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(4, 1)">关于我们</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a @click="toSubNav(4, 2)">新闻中心</a>
                  </div>
                </div>
                <div class="item">
                  <div class="">
                    <a href="https://sailyond.jobs.feishu.cn/749776">加入我们</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>



      </ul>

      <div class="wap">
        <img src="../assets/img/home/public/wapIcon.png" @click="wapNav = true" v-show="wapNav == false">
        <img src="../assets/img/home/public/closeIcon.png" @click="wapNav = false" v-show="wapNav == true">
      </div>

    </header>

    <div class="wapNav" v-show="wapNav">
      <ul>
        <li @click="toSubNav(0, 0)">首页</li>
        <li @click="toggleNav(1)">
          <p>产品中心</p>
          <img src="../assets/img/home/public/rightArrowIcon.png" class="rightArrow" v-show="activeMolideNav != 1">
          <img src="../assets/img/home/public/downArrowIcon.png" class="downArrow" v-show="activeMolideNav == 1">
        </li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 1)">2D-AOI PCBA检测设备</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 2)">3D-AOI PCBA检测设备</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 3)">3D-SPI锡膏检测设备</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 4)">DIP-AOI插件检测设备</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 5)">AI智能相机</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 6)">智能光源系统</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 7)">AI智能盒子</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 8)">双目结构光3D相机</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 9)">视觉应用平台</li>
        <li v-show="activeMolideNav == 1" class="wapSubnav" @click="toSubNav(1, 10)">算法生成平台</li>
        <li @click="toggleNav(2)">
          <p>核心技术</p>
          <img src="../assets/img/home/public/rightArrowIcon.png" class="rightArrow" v-show="activeMolideNav != 2">
          <img src="../assets/img/home/public/downArrowIcon.png" class="downArrow" v-show="activeMolideNav == 2">
        </li>
        <li v-show="activeMolideNav == 2" class="wapSubnav" @click="toSubNav(2, 1)">AutoML</li>
        <li v-show="activeMolideNav == 2" class="wapSubnav" @click="toSubNav(2, 2)">可信赖AI</li>
        <li v-show="activeMolideNav == 2" class="wapSubnav" @click="toSubNav(2, 3)">主动学习</li>
        <li v-show="activeMolideNav == 2" class="wapSubnav" @click="toSubNav(2, 4)">小样本学习</li>
        <li v-show="activeMolideNav == 2" class="wapSubnav" @click="toSubNav(2, 5)">联邦学习</li>
        <li @click="toggleNav(3)">
          <p>行业应用</p>
          <img src="../assets/img/home/public/rightArrowIcon.png" class="rightArrow" v-show="activeMolideNav != 3">
          <img src="../assets/img/home/public/downArrowIcon.png" class="downArrow" v-show="activeMolideNav == 3">
        </li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 1)">半导体晶圆</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 2)">电子元器件</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 3)">新能源电池</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 4)">太阳能光伏</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 5)">3C电子</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 6)">汽车制造</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 7)">纺织工业</li>
        <li v-show="activeMolideNav == 3" class="wapSubnav" @click="toSubNav(3, 8)">细菌检测</li>
        <li @click="toggleNav(4)">
          <p>关于识渊</p>
          <img src="../assets/img/home/public/rightArrowIcon.png" class="rightArrow" v-show="activeMolideNav != 4">
          <img src="../assets/img/home/public/downArrowIcon.png" class="downArrow" v-show="activeMolideNav == 4">
        </li>
        <li v-show="activeMolideNav == 4" class="wapSubnav" @click="toSubNav(4, 1)">关于我们</li>
        <li v-show="activeMolideNav == 4" class="wapSubnav" @click="toSubNav(4, 2)">新闻中心</li>
        <li v-show="activeMolideNav == 4" class="wapSubnav" @click="toSubNav(4, 3)">加入我们</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    activeNav: null,
    activeSubnav: null,
  },
  data() {
    return {
      // 移动端菜单显示隐藏
      wapNav: false,
      // 移动端选中导航
      activeMolideNav: null,
    }
  },
  mounted() {
  },
  methods: {
    toSubNav(nav, subNav) {
      let flag = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)
      let isTop = false
      if (flag) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (scrollTop == 0) {
          isTop = true
        }
      }

      // 首页
      if (nav == 0) {
        this.$router.push({
          path: '/'
        })
        this.$parent.$refs.fullpage.api.moveTo(1)
      }

      // 产品中心
      else if (nav == 1) {
        if (subNav == 0) {
          this.$router.push({
            name: 'ProdTab3'
          })
        }
        // 工业质检行业专机
        else if (subNav == 1 || subNav == 2 || subNav == 3 || subNav == 4) {
          this.$router.push({
            name: 'InspectionTab' + subNav
          })
          if (this.activeNav == 1 && this.activeSubnav == 1) {
            this.$parent.activeTab = subNav

            window.scrollTo({
              left: 0,
              top: (window.innerWidth * 1170 / 1200) + 60,
              behavior: 'auto'
            })
          }
        }
        // 智能模组产品
        else if (subNav == 5 || subNav == 6 || subNav == 7 || subNav == 8) {
          this.$router.push({
            name: 'IndustryTab' + (subNav - 4)
          })
          if (this.activeNav == 1 && this.activeSubnav == 2) {
            this.$parent.activeTab = subNav - 4

            if (isTop == false) {
              window.scrollTo({
                left: 0,
                top: (window.innerWidth * 1170 / 1200) + 60,
                behavior: 'auto'
              })
            }
          }

        }
        // 智能平台 视觉应用平台
        else if (subNav == 9) {
          this.$router.push({
            name: 'VisualApplication'
          })

          if (this.activeNav == 1 && this.activeSubnav == 3) {
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'auto'
            })
          }
        }
        // 智能平台 算法生成平台
        else if (subNav == 10) {
          this.$router.push({
            name: 'AlgorithmGeneration'
          })

          if (this.activeNav == 1 && this.activeSubnav == 3) {
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'auto'
            })
          }
        }
      }

      // 核心技术
      else if (nav == 2) {
        if (subNav == 0) {
          this.$router.push({
            name: 'TechTab' + (subNav + 1)
          })

          if (this.activeNav == 2) {
            this.$parent.swiper.slideToLoop(subNav, 1000, false)
          }

        } else {
          this.$router.push({
            name: 'TechTab' + subNav
          })

          if (this.activeNav == 2) {
            this.$parent.swiper.slideToLoop(subNav - 1, 1000, false)
          }
        }

        if (this.activeNav == 2) {
          if (isTop == false) {
            const Top = document.getElementById('swiperTab')
            Top.scrollIntoView({ behavior: 'auto' })
          }
        }

      }

      // 行业应用
      else if (nav == 3) {
        if (subNav == 0) {
          this.$router.push({
            name: 'AppTab' + (subNav + 1)
          })

          if (this.activeNav == 3) {
            this.$parent.activeTab = subNav + 1
          }
        } else {
          this.$router.push({
            name: 'AppTab' + subNav
          })

          if (this.activeNav == 3) {
            this.$parent.activeTab = subNav
          }
        }

        if (this.activeNav == 3) {
          if (isTop == false) {
            window.scrollTo({
              left: 0,
              top: (window.innerWidth * 1170 / 1200) + 60,
              behavior: 'auto'
            })
          }
        }
      }

      // 关于识渊
      else if (nav == 4) {
        // 关于我们
        if (subNav == 0 || subNav == 1) {
          this.$router.push({
            name: 'AboutSailyond'
          })
        }
        // 新闻中心
        else if (subNav == 2) {
          this.$router.push({
            name: 'News'
          })
        }
        // 加入我们
        else if (subNav == 3) {
          window.open("https://sailyond.jobs.feishu.cn/749776")
        }
      }

      if (this.activeNav !== nav || subNav == 0 || (this.activeNav == nav && subNav == 9) || (this.activeNav == nav && subNav == 10)) {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        })
      }
      this.wapNav = false
    },
    // 移动端菜单收起和展开
    toggleNav(val) {
      if (val == this.activeMolideNav) {
        this.activeMolideNav = null
      } else {
        this.activeMolideNav = val
      }
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Header.vue